import { isEmpty } from 'lodash'

export default (searchedBy, filters, agenda) => {
  console.log(agenda)
  if (!isEmpty(agenda.speciality.id)) {
    filters['specialities'] = {
      id: agenda.speciality.id
    }
    searchedBy.push(agenda.speciality.name)
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/filters/filterBySpecialities.js